import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Home.css';


const Home = () => {
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1 className="hero-title">Bricks & Brain</h1>
          <p className="hero-subtitle">Building Strong Foundations with Smart Solutions</p>
          <p className="hero-description">
            Transforming visions into reality with precision engineering, innovative design, 
            and uncompromising quality standards.
          </p>
          <div className="hero-buttons">
            <Link to="/services" className="btn-primary">Our Services</Link>
            <Link to="/contact" className="btn-secondary">Contact Us</Link>
          </div>
        </div>
      </section>


      {/* Features Section */}
      <section className="features-section">
        <div className="container">
          <h2 className="section-title">Why Choose Us</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🏆</div>
              <h3>Quality</h3>
              <p>Superior craftsmanship and premium materials in every project</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🛡️</div>
              <h3>Safety</h3>
              <p>Strict adherence to safety protocols and building standards</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">💡</div>
              <h3>Innovation</h3>
              <p>Cutting-edge construction techniques and smart building solutions</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">⏰</div>
              <h3>On-Time Delivery</h3>
              <p>Committed to completing projects within agreed timelines</p>
            </div>
          </div>
        </div>
      </section>


      {/* Statistics Section */}
      <section className="statistics-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-number">15+</div>
              <div className="stat-label">Years Experience</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">500+</div>
              <div className="stat-label">Projects Completed</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">350+</div>
              <div className="stat-label">Happy Clients</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">50+</div>
              <div className="stat-label">Expert Team</div>
            </div>
          </div>
        </div>
      </section>


      {/* Testimonials Section */}
      <section className="testimonials-section">
        <div className="container">
          <h2 className="section-title">What Our Clients Say</h2>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <div className="testimonial-stars">⭐⭐⭐⭐⭐</div>
              <p className="testimonial-text">
                "Bricks & Brain transformed our vision into reality. Their attention to detail 
                and commitment to quality is unmatched. Highly recommended!"
              </p>
              <div className="testimonial-author">
                <strong>Rajesh Kumar</strong>
                <span>Homeowner, Mumbai</span>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-stars">⭐⭐⭐⭐⭐</div>
              <p className="testimonial-text">
                "Professional, reliable, and delivered on time. The team's expertise in 
                commercial construction exceeded our expectations."
              </p>
              <div className="testimonial-author">
                <strong>Priya Sharma</strong>
                <span>Business Owner, Pune</span>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-stars">⭐⭐⭐⭐⭐</div>
              <p className="testimonial-text">
                "From planning to execution, everything was handled with utmost professionalism. 
                Our office renovation looks absolutely stunning!"
              </p>
              <div className="testimonial-author">
                <strong>Amit Patel</strong>
                <span>Corporate Client, Vasai</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};


export default Home;
